import { useConfirmAssessment } from "@/api/console/assessment-progresses/useConfirmAssessment";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { STATUS } from "@/config/progress";
import { handleCompanyName } from "@/lib/handleName";
import toast from "@/lib/toast";
import useAssessmentDialog from "@/src/console/(auth)/(confirm-assessments)/assessments/_hooks/useAssessmentDialog";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";

function ConfirmAssessmentDialog() {
  const { t } = useTranslation();
  const { type, assessment, resetDialog } = useAssessmentDialog();
  const assessmentId = assessment?.id ?? -1;
  const companyName = handleCompanyName(assessmentId, assessment?.company_name);

  const { trigger: confirm, isMutating } = useConfirmAssessment(assessmentId, {
    onSuccess: (data) => {
      resetDialog();
      mutate(
        `/console/assessment_progresses?status=${STATUS.IMPROVEMENT_PROPOSAL_COMPLETED}`,
      );
      toast.success(data.message);
    },
  });

  return (
    <Dialog
      open={type === "confirm"}
      onOpenChange={(open) => !open && resetDialog()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("finalize-assessment")}</DialogTitle>
        </DialogHeader>
        <div className=" flex flex-col p-6">
          {`${companyName} の評価を確定してもよろしいですか？確定後は企業が評価結果を確認できるようになります。`}
          <div className=" flex flex-row mt-8 ml-auto space-x-4">
            <Button onClick={() => resetDialog()} variant="ghost">
              {t("cancel")}
            </Button>
            <Button
              LoadingComponent={<SpinnerIosRegular className="animate-spin" />}
              isLoading={isMutating}
              onClick={() => confirm()}
            >
              {t("confirm")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmAssessmentDialog;
